import { render, staticRenderFns } from "./GoldenTicketExt.vue?vue&type=template&id=7e63b436&scoped=true&"
import script from "./GoldenTicketExt.vue?vue&type=script&lang=js&"
export * from "./GoldenTicketExt.vue?vue&type=script&lang=js&"
import style0 from "./GoldenTicketExt.vue?vue&type=style&index=0&id=7e63b436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63b436",
  null
  
)

export default component.exports